import React, { memo, useState } from "react";

// ReactFlow Library
import { NodeResizer, Handle, Position } from "reactflow";

// Node Utils
import nodeUtils from "../utilities/nodeUtils";

export default memo(
  ({ data, id, selected, sourcePosition, targetPosition }) => {
    const { updateNodeData } = nodeUtils();
    const [inputValues, setInputValues] = useState({
      title: data.title ?? "",
    });

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setInputValues((prev) => ({ ...prev, [name]: value }));
      updateNodeData(id, { [name]: value });
    };

    return (
      <div className="customNode titleNode">
        {!data.isFront && (
          <NodeResizer
            color="#3c8dbc"
            isVisible={selected}
            minWidth={225}
            minHeight={76}
          />
        )}
        <input
          className="form-control"
          type="text"
          name="title"
          value={inputValues.title}
          id={`title-${id}`}
          onChange={handleInputChange}
          disabled={data.isFront}
        />
        <Handle id="top" type="target" position={Position.Top} />
        <Handle
          id="right"
          type="target"
          position={
            sourcePosition && !["top", "bottom"].includes(sourcePosition)
              ? sourcePosition
              : Position.Right
          }
        />
        <Handle id="bottom" type="target" position={Position.Bottom} />
        <Handle
          id="left"
          type="target"
          position={
            targetPosition && !["top", "bottom"].includes(targetPosition)
              ? targetPosition
              : Position.Left
          }
        />
      </div>
    );
  }
);
